import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import { useAuthStore } from './stores/auth';
import './styles/main.css';

async function bootstrap(): Promise<void> {
  const app = createApp(App);
  app.use(createPinia());
  app.use(router);

  // Bootstrap MSAL + identity before mounting so the router guard can rely on
  // the auth store having an answer rather than racing initial navigation.
  const auth = useAuthStore();
  await auth.bootstrap();

  app.mount('#app');
}

void bootstrap();
